
import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AIAssistant from "./AIAssistant";
import CookieConsent from "./CookieConsent";
import AdminAccessButton from "./AdminAccessButton";
import SupabaseRestrictionBanner from "./SupabaseRestrictionBanner";

import { NavbarLogoProvider } from "@/contexts/NavbarLogoContext";

const Layout = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  // Pass tab parameter to the Outlet context if it exists
  const outletContext = location.search.includes('tab=') ? 
    { tab: new URLSearchParams(location.search).get('tab') } : 
    {};

  // Check if current page is admin to hide MiniContactForm
  const isAdminPage = location.pathname.includes("/admin");
  const isHomePage = location.pathname === "/";

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const content = (
    <div className="flex flex-col min-h-screen bg-bbz-cream">
      
      <Navbar isOpen={isMenuOpen} toggle={toggleMenu} isHomePage={isHomePage} />
      {!isAdminPage && <SupabaseRestrictionBanner />}
      <main className="flex-grow">
        <Outlet context={outletContext} />
        {!isAdminPage && <AIAssistant />}
      </main>
      <Footer />
      {!isAdminPage && <CookieConsent />}
      {!isAdminPage && <AdminAccessButton />}
    </div>
  );

  return isHomePage ? (
    <NavbarLogoProvider>{content}</NavbarLogoProvider>
  ) : (
    content
  );
};

export default Layout;
